
import {  Component, FormModalMixins, Prop } from "@/lib";
import DeclareCustoms from "@/store/modules/shipment/declarecustoms/entity";
import DeclareGroup from "@/store/modules/shipment/declaregroup/entity";

class SearchData {
  shippingNumber:string;
  constructor() {
    this.shippingNumber = "";
  }
}

@Component
export default class CopyDeclareGroupModel extends FormModalMixins {
  @Prop({type: String}) targetShippingNumber: string;// 目标记录的运编号
  model = new DeclareCustoms();

  searchModel = new SearchData();
  loading: boolean = false;

  setSizeUnit(unit) {
    return unit === this.$appconst.unit.size;
  }
  setdotNumber(isSizeUnit) {
    return isSizeUnit ? 2 : 0;
  }

  quantity(row) {
    let dotNumber = this.setdotNumber(this.setSizeUnit(row.unit));
    return !!row.quantity || row.quantity === 0 ? row.quantity.toFixed(dotNumber) : row.quantity
  }

  get shipmentList() {
    let list = [];
    if (!!this.model.declareGroupList && this.model.declareGroupList.length > 0) {
      const poNumberText = this.L('app.DeclareGroup.PoNumber');
      this.model.declareGroupList.forEach((item, index) => {
        // 当PO#和总品名都没有填写，则Talbe中不增加组名行
        let hasGroup = false;
        let childLength = item.productList.length;
        if (!!item.poNumber || !!item.groupName) {
          list.push({
            rowspan: childLength + 1,
            isGroup: true,
            isTitle: true,
            dataIndex: index,// 序号
            rowIndex: index + 1,// 显示的序号
            poNumber: !!item.poNumber ? `${poNumberText}${item.poNumber}` : "",
            groupName: item.groupName
          })
          hasGroup = true;
        }

        item.productList.forEach((productItem, productItemIndex) => {
          list.push({
            rowspan: hasGroup || productItemIndex !== 0 ? 0 : childLength,
            isGroup: false,
            isTitle: !hasGroup,
            dataIndex: index,// 序号
            rowIndex: index + 1,// 显示的序号
            productName: `${productItem.productNameEn}/${productItem.productName}`,
            boxCount: productItem.boxCount,
            quantity: productItem.quantity,
            totalGrossWeight: productItem.totalGrossWeight,
            totalNetWeight: productItem.totalNetWeight,
            price: productItem.price,
            totalAmount: productItem.totalAmount,
            productCode: productItem.productCode,
            unit: productItem.unit,
            factoryId: productItem.factoryId,
            factoryName: productItem.factoryName,
            domesticSourceOfGood: productItem.domesticSourceOfGood
          })
        })
      })
    };
    return list;
  }

  created() {
    Object.assign(this.config,{
        labelWidth: 80,
        modelTitleL: "app.Title.CopyDetail",
        width: 1400,
        okText: "Action.Ok"

    })
  }

  get column() {
    return [
      this.$util.render.baseColumn("app.SystemCode.SequenceNo", 80, {key: "rowIndex", align: 'center'}),
      this.$util.render.baseColumn("app.DeclareGroup.ProductName", null, {slot: "productName", minWidth: 200}),
      this.$util.render.baseColumn("app.DeclareGroup.BoxCount", null, {key: "boxCount", width: 110, align: 'right'}),
      this.$util.render.baseColumn("app.DeclareGroup.Quantity", null, {slot: "quantity", key: "quantity", width: 100, align: 'right'}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalGrossWeight", null, {key: "totalGrossWeight", minWidth: 120, align: 'right', render: (h: any, params: any) => {
        return [h("span", !!params.row.totalGrossWeight || params.row.totalGrossWeight === 0 ? params.row.totalGrossWeight.toFixed(2) : "")];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalNetWeight", null, {key: "totalNetWeight", minWidth: 120, align: 'right', render: (h: any, params: any) => {
        return [h("span", !!params.row.totalNetWeight || params.row.totalNetWeight === 0 ? params.row.totalNetWeight.toFixed(2) : "")];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.Price", null, {key: "price", width: 100, align: 'right', render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.price))];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalAmount", null, {key: "totalAmount", align: 'right', minWidth: 140, render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.totalAmount))];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.ProductCode", null, {key: "productCode", minWidth: 120}),
      this.$util.render.baseColumn("app.Factory.FactoryName", null, {key: "factoryName", width: 108}),
      this.$util.render.baseColumn("app.DeclareCustoms.DomesticSourceOfGood", null, {key: "domesticSourceOfGood", width: 108}),
      this.$util.render.baseColumn("Action.Actions", null, {slot: "actions", width: 100, fixed: 'right'})
    ];
  }
  
  /**
   * 合并单元格
   */
  handleSpan ({ row, column, rowIndex, columnIndex }) {
    if (columnIndex == 0 || columnIndex == 11) {
      return {
          rowspan: row.rowspan,
          colspan: 1
      };
    }
  }

  async query() {
    if (!this.searchModel.shippingNumber) {
      return;
    }
    if (this.targetShippingNumber === this.searchModel.shippingNumber) {
      this.$Modal.warning({
          title: this.L("MessageTitle.Tips"),
          content: this.L("app.CustomsDeclarationElement.NotCopyOneSelf")
      });
      return;
    }
    this.loading = true;
    try {
      this.model = await this.$store.dispatch("shipment/declaregroup/getShipmentList", this.searchModel);
    } finally {
      this.loading = false;
    }
  }

  copyChange(value, dataIndex) {
    this.model.declareGroupList[dataIndex].isCopy = value;
  }

  close() {
    this.config.isShow = false;
    this.model = new DeclareCustoms();
    this.searchModel = new SearchData();
  }

  rowClassName (row, index) {
    if (row.isTitle) {
      return 'hi-table-group-row';
    }
    return '';
  }
}

